import { createContext } from "react";

import { ReferralsContextType } from "./ReferralsContext.types";

export const ReferralsContext = createContext<ReferralsContextType | undefined>(undefined);
